const shouldHighlight = (subItem, menuItem, comparisonData) => {
  if (menuItem.text === 'bfsz' && subItem.text === 'project_overview') {
    return String(subItem.element_id) === String(comparisonData.id) && comparisonData?.path?.includes(subItem.text);
  } else if (menuItem.text === 'elster') {
    return String(subItem.element_id) === String(comparisonData.id) && comparisonData.step.includes(menuItem.text);
  } else if (menuItem.text === 'hidden_elsters') {
    return String(subItem.element_id) === String(comparisonData.id) && menuItem.text.includes(comparisonData.step);
  }
};
export const highlightSubMenuItem = (menuItemList, comparisonData) => {
  if (!menuItemList?.length || !comparisonData?.id) return [];
  return menuItemList.map(menuItem => {
    if (menuItem?.subMenu) {
      return {
        ...menuItem,
        subMenu: menuItem.subMenu.map(subItem => shouldHighlight(subItem, menuItem, comparisonData) ? {
          ...subItem,
          highlighted: true
        } : subItem)
      };
    }
    return {
      ...menuItem
    };
  });
};